export enum SocialNetworkConnectionStatus {
  CONNECTED = 'CONNECTED',
  PENDING = 'PENDING',
  BLOCKED = 'BLOCKED',
  NOT_CONNECTED = 'NOT_CONNECTED',
  WAITING_FEEDBACK = 'WAITING_FEEDBACK',
  NOT_VISIBLE = 'NOT_VISIBLE',
  IS_YOU = 'IS_YOU',
}
